import React, { useState, useEffect } from 'react';
import { useLocation } from 'umi';

/**
 * 从URL路径中解析出当前应该激活的tab
 * @param activeIds - 有效的tab id数组
 * @param defaultActiveId - 默认的tab id
 * @param pathname - URL路径
 * @returns tab的id
 */
const parseActiveIdFromPath = (activeIds: string[], defaultActiveId: string, pathname: string): string => {
  const pathParts = pathname.split('/').filter(Boolean);
  const lastPart = pathParts[pathParts.length - 1];

  // 验证是否是有效的tab id
  if (activeIds.includes(lastPart)) {
    return lastPart;
  }

  return defaultActiveId;
};

export default function useUrlSyncActiveId(
  activeIds: string[],
  defaultActiveId: string,
): [string, React.Dispatch<React.SetStateAction<string>>] {
  const location = useLocation();

  // 初始化时从URL解析activeId
  const [activeId, setActiveId] = useState(() => {
    return parseActiveIdFromPath(activeIds, defaultActiveId, location.pathname);
  });

  // 监听URL变化，同步更新activeId
  // 这样可以确保浏览器前进/后退按钮、直接访问URL等场景下tab状态正确
  useEffect(() => {
    const newActiveId = parseActiveIdFromPath(activeIds, defaultActiveId, location.pathname);
    if (newActiveId !== activeId) {
      setActiveId(newActiveId);
    }
  }, [location.pathname]);

  return [activeId, setActiveId];
}
